class DynamicThumbnailGallery {
  constructor(mediaGallery) {
    this.mediaGallery = mediaGallery;
    this.thumbnailContainer = mediaGallery.querySelector('[id^="GalleryThumbnails"]');
    this.mainViewer = mediaGallery.querySelector('[id^="GalleryViewer"]');

    if (!this.thumbnailContainer || !this.mainViewer) return;

    this.thumbnails = Array.from(this.thumbnailContainer.querySelectorAll('.thumbnail-list__item'));
    this.currentMainId = null;

    this.init();
  }

  init() {
    // Find the currently active main image
    const activeMainMedia = this.mainViewer.querySelector('.is-active[data-media-id]');
    if (activeMainMedia) {
      this.currentMainId = activeMainMedia.dataset.mediaId;
    }

    // Set up initial thumbnail visibility (show 3, hide the one that's currently main)
    this.updateThumbnailVisibility();

    // Add click handlers to thumbnails
    this.thumbnails.forEach((thumbnail) => {
      const button = thumbnail.querySelector('button');
      if (button) {
        // Remove existing click handler to prevent conflicts
        button.removeEventListener('click', this.originalClickHandler);
        // Add our custom handler
        button.addEventListener('click', (e) => this.handleThumbnailClick(e, thumbnail));
      }
    });
  }

  handleThumbnailClick(event, clickedThumbnail) {
    event.preventDefault();
    event.stopPropagation();

    const targetMediaId = clickedThumbnail.dataset.target;
    if (!targetMediaId || targetMediaId === this.currentMainId) return;

    // Switch the main image using existing Shopify functionality
    this.switchMainImage(targetMediaId);

    // Update tracking
    this.currentMainId = targetMediaId;

    // Update thumbnail visibility
    this.updateThumbnailVisibility();
  }

  switchMainImage(mediaId) {
    // Use the existing media gallery setActiveMedia method if available
    if (this.mediaGallery.setActiveMedia) {
      this.mediaGallery.setActiveMedia(mediaId, false);
    } else {
      // Fallback: manually switch active states
      const activeMedia = this.mainViewer.querySelector(`[data-media-id="${mediaId}"]`);
      if (!activeMedia) return;

      // Remove active class from all media
      this.mainViewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });

      // Add active class to new media
      activeMedia.classList.add('is-active');

      // Update thumbnail active states
      this.thumbnails.forEach((thumb) => {
        const button = thumb.querySelector('button');
        if (button) {
          if (thumb.dataset.target === mediaId) {
            button.setAttribute('aria-current', 'true');
          } else {
            button.removeAttribute('aria-current');
          }
        }
      });
    }
  }

  updateThumbnailVisibility() {
    let visibleCount = 0;

    this.thumbnails.forEach((thumbnail) => {
      const targetMediaId = thumbnail.dataset.target;

      // Hide thumbnail if it's the current main image OR already have 3 visible
      if (targetMediaId === this.currentMainId || visibleCount >= 3) {
        thumbnail.classList.add('hidden');
      } else {
        thumbnail.classList.remove('hidden');
        visibleCount++;
      }
    });
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  // Wait for the original media gallery to initialize
  setTimeout(() => {
    const mediaGalleries = document.querySelectorAll('media-gallery');
    mediaGalleries.forEach((gallery) => {
      new DynamicThumbnailGallery(gallery);
    });
  }, 100);
});

// Initialize any dynamic content changes
if (window.MutationObserver) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        const addedMediaGalleries = Array.from(mutation.addedNodes)
          .filter((node) => node.nodeType === 1)
          .flatMap((node) => [
            ...(node.matches && node.matches('media-gallery') ? [node] : []),
            ...node.querySelectorAll('media-gallery'),
          ]);

        addedMediaGalleries.forEach((gallery) => {
          new DynamicThumbnailGallery(gallery);
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}
